import { render, staticRenderFns } from "./Advertiser_Overall_Details.vue?vue&type=template&id=1513a9cd&scoped=true&"
import script from "./Advertiser_Overall_Details.vue?vue&type=script&lang=js&"
export * from "./Advertiser_Overall_Details.vue?vue&type=script&lang=js&"
import style0 from "./Advertiser_Overall_Details.vue?vue&type=style&index=0&id=1513a9cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513a9cd",
  null
  
)

export default component.exports